import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { useUnitJourneyContext } from "@/hooks/useUnitJourneyContext";
import { CirrusReservation } from "@glidevvr/cirrus-reservation-funnel";
import "@glidevvr/cirrus-reservation-funnel/dist/index.css";

import type { RootState } from "@/store";
import { useSelector } from "react-redux";
import { FunnelType } from "@/lib/utils";

interface UnitFunnelProps {
    type: string;
    selectedUnitId: number | string;
}
export const UnitFunnel = ({ selectedUnitId }: UnitFunnelProps) => {
    const unitContext = useUnitItemContext();
    const { unitGroup } = unitContext;
    const { funnelType } = useUnitJourneyContext();

    const apiKey = useSelector((state: RootState) => state.apiKey);

    return (
        <div>
            {funnelType === FunnelType.RENT && (
                <div
                    className="rental-funnel-root"
                    id={`unitFunnel${selectedUnitId}`}
                >
                    Funnel to Attach Here
                </div>
            )}
            {funnelType === "reserve" && (
                <CirrusReservation
                    apiKey={apiKey}
                    environment={import.meta.env.VITE_SE_ENVIRONMENT}
                    facilityId={unitGroup.representative_unit.facility_id}
                    unitId={Number(selectedUnitId)}
                    promotionId={Number(unitContext.selectedPromo)}
                    reservationType="HARD"
                />
            )}
            {funnelType === "quote" && <div>Lead funnel to attach here</div>}
        </div>
    );
};